const reqs_traslado = state => state.reqs_traslado;

export default {
  reqs_traslado,
};